import React, { useState, useEffect } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import { useTheme } from '../theme/useTheme';
import { GlobalStyles } from "../theme/createGlobalStyles";
import { ThemeProvider as ThemeProviderSc } from 'styled-components';


const ThemeProvider = (props) => {
    const { theme, themeLoaded } = useTheme();
    const [selectedTheme, setSelectedTheme] = useState(theme);
    const [brandConfig, setBrandConfig] = useState({
        isLoading: false,
        data: null
    })
    const value = { selectedTheme, setSelectedTheme, brandConfig, setBrandConfig }
    useEffect(() => {
        setSelectedTheme(theme);
    }, [themeLoaded]);


    return (
        <>
            {themeLoaded && (<ThemeContext.Provider value={value}>
                <ThemeProviderSc theme={selectedTheme}>
                    <GlobalStyles />
                    {props.children}
                </ThemeProviderSc>
            </ThemeContext.Provider>)}

        </>
    )
};

export default ThemeProvider;
